import CryptoJS from 'crypto-js'

const SESSION_KEY_NAME = '__pogi_admin_session_key'

const getSessionKey = () => {
  let key = sessionStorage.getItem(SESSION_KEY_NAME)

  if (!key) {
    key = CryptoJS.lib.WordArray.random(256 / 8).toString()
    sessionStorage.setItem(SESSION_KEY_NAME, key)
  }

  return key
}

// This is only for short-lived UI data, not authentication tokens.
// Access/refresh tokens are stored in sessionStorage by jwtService.
export const encrypt = value => CryptoJS.AES.encrypt(String(value ?? ''), getSessionKey()).toString()

export const decrypt = value => {
  if (!value) return value

  try {
    const bytes = CryptoJS.AES.decrypt(value, getSessionKey())
    return bytes.toString(CryptoJS.enc.Utf8)
  } catch (error) {
    return null
  }
}
